"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeState = void 0;
const rc_js_util_1 = require("rc-js-util");
/**
 * @public
 * {@inheritDoc IAttributeState}
 */
class AttributeState {
    constructor(attribute, buffer) {
        this.buffer = buffer;
        this.attributes = [attribute];
    }
    addAttribute(attribute) {
        DEBUG_MODE && rc_js_util_1._Debug.assert(this.attributes.indexOf(attribute) === -1, "attribute has already been linked");
        this.attributes.push(attribute);
    }
}
exports.AttributeState = AttributeState;
//# sourceMappingURL=attribute-state.js.map